import ko from 'knockout';

export default class ViewModel {
  constructor({
    value = '',
    isDisabled = false,
  } = {}) {
    this.isDisabled = ko.observable(isDisabled);
    this.value = ko.observable(value);
  }
}
